export const LOAD_PROJECTS = "LOAD_PROJECTS";
export const ERROR_PROJECTS = "ERROR_PROJECTS";